<template>
  <div class="researchEducation">
    <template v-if="!isIndex">
      <el-tabs
        :tab-position="tabPosition"
        :value="activateName"
        style="height: auto"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="lan ? 'Activity-Study' : '研学活动'"
          name="研学活动"
        >
          <template v-if="curIndex == 0">
            <div
              class="researchSlider-box"
              v-for="(item, index) in researchList"
              :key="item.id"
            >
              <Swiper :showData="item.researchImg" :showIndex="index" />
              <div class="research-title-do">
                {{ lan ? item.activityEnTitle : item.activityCnTitle }}
              </div>
              <div class="research-info">
                {{ lan ? item.activityEnBrief : item.activityCnBrief }}
              </div>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane
          :label="lan ? 'Activity-Teach' : '公教活动'"
          name="公教活动"
        >
          <template v-if="curIndex == 1">
            <div
              class="researchSlider-box"
              v-for="(item, index) in educationList"
              :key="item.id"
            >
              <Swiper :showData="item.educationImg" :showIndex="index" />
              <div class="activityTeach-info">
                <div class="activityTeach-do">
                  <div class="activityTeach-title">
                    {{
                      lan ? item.activityEnSubTitle : item.activityCnSubTitle
                    }}
                  </div>
                  <div
                    class="activityTeach-time"
                    v-if="item.startDate"
                  >
                    {{ formatActivityDate(item.startDate, item.endDate) }}
                  </div>
                </div>
                <div class="research-title-do">
                  {{ lan ? item.activityEnTitle : item.activityCnTitle }}
                </div>
                <div class="research-info">
                  <div v-html="lan ? item.contentEn : item.contentCn"></div>
                </div>
              </div>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <div class="wap-act-tab">
        <div
          class="wap-tab"
          @click="actTap(0)"
          :class="{ actTap: curIndex == 0 }"
        >
          研学活动
        </div>
        <div
          class="wap-tab"
          @click="actTap(1)"
          :class="{ actTap: curIndex == 1 }"
        >
          公教活动
        </div>
      </div>
      <div class="wap-researchEducation">
        <template v-if="curIndex == 0">
          <div
            class="researchSlider-box"
            v-for="(item, index) in researchList"
            :key="item.id"
          >
            <Swiper :showData="item.researchImg" :showIndex="index" />
            <div class="research-title-do">
              {{ lan ? item.activityEnTitle : item.activityCnTitle }}
            </div>
            <div class="research-info">
              {{ lan ? item.activityEnBrief : item.activityCnBrief }}
            </div>
          </div>
        </template>
        <template v-else-if="curIndex == 1">
          <div
            class="researchSlider-wap"
            v-for="(item, index) in educationList"
            :key="item.id"
          >
            <Swiper :showData="item.educationImg" :showIndex="index" />
            <div class="activity-box-wap">
              <div class="activity-wap">
                <div class="res-wap">
                  {{ lan ? item.activityEnTitle : item.activityCnTitle }}
                </div>
                <div class="reswap-title">
                  {{ lan ? item.activityEnSubTitle : item.activityCnSubTitle }}
                </div>
                <div class="reswap-time" v-if="item.startDate">
                  {{ formatActivityDate(item.startDate, item.endDate) }}
                </div>
              </div>
              <div class="research-info-wap">
                <div v-html="lan ? item.contentEn : item.contentCn"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import Swiper from "../components/swiper.vue";
export default {
  name: "researchEducation",
  components: {
    Swiper,
  },
  data() {
    return {
      isIndex: false,
      tabPosition: "left",
      activateName: "研学活动",
      lan: this.$store.state.isEn,
      researchList: [],
      educationList: [],
      curIndex: 0,
      activityTeach: [],
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  mounted() {
    this.init();
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      this.isIndex = !event.matches;
      this.actTap(0);
    },
    // 格式化活动日期显示
    formatActivityDate(startDate, endDate) {
      // 如果没有结束日期或者开始日期和结束日期相同，则只显示开始日期
      if (!endDate || startDate === endDate) {
        return startDate || '';
      }
      // 否则显示日期范围格式
      return `${startDate || ''}-${endDate || ''}`;
    },
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    // 提取图片数据处理逻辑
    processImageData(data, imageKey, targetKey) {
      data.forEach((el) => {
        if (el.image) {
          el[targetKey] = JSON.parse(el.image);
        }
        // 处理英文富文本内容中的中文双引号
        el.contentEn = this.replaceChineseQuotes(el.contentEn);
      });
      return data;
    },
    // 统一获取活动列表方法
    async getActivityList(activityType, targetKey, targetList) {
      await this.$api.get(
        "/activity/list",
        { current: 1, pageSize: 10, activityType: activityType },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            const processedData = this.processImageData(data, 'image', targetKey);
            this[targetList] = processedData;
          }
        }
      );
    },
    async actTap(ev) {
      this.curIndex = ev;
      if (ev == 1) {
        await this.getActivityList(4, 'educationImg', 'educationList');
      } else {
        await this.getActivityList(3, 'researchImg', 'researchList');
      }
    },
    async init() {
      // 使用Promise.all并行执行不依赖的请求
      await Promise.all([
        this.getActivityList(3, 'researchImg', 'researchList'),
        this.getActivityList(4, 'educationImg', 'educationList'),
        this.$api.get(
          "/advert/list",
          { current: 1, pageSize: 10, advertFlagName: "activity-teach" },
          (r) => {
            const { data, code } = r;
            if (code == 0) {
              this.activityTeach = JSON.parse(JSON.stringify(data));
            }
          }
        )
      ]);
    },
    async handleClick(tab, event) {
      this.curIndex = parseInt(tab.index);
      if (tab.index == 1) {
        await this.getActivityList(4, 'educationImg', 'educationList');
      } else {
        await this.getActivityList(3, 'researchImg', 'researchList');
      }
    },
  },
};
</script>
<style scoped>
.researchEducation {
  width: 1440px;
  margin: 164px auto 100px;
}
/* 去掉tabs标签栏下的下划线 */
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
  /* background-color: #fff; */
}
::v-deep .el-tabs__nav {
  width: 240px;
}
/* 下划线切换高亮 */
::v-deep .el-tabs__active-bar {
  background-color: transparent;
}
/* 鼠标选中时样式 */
::v-deep .el-tabs__item.is-active {
  color: #ca9d76;
  opacity: 1;
}
/* 鼠标悬浮时样式 */
::v-deep .el-tabs__item:hover {
  cursor: pointer;
  opacity: 1;
  color: #ca9d76;
}
::v-deep .el-tabs__item {
  font-family: SourceHanSansCN-Bold;
  font-size: 28px;
  color: #98989f;
  font-weight: 600;
  margin-bottom: 24px;
}
.researchSlider-box {
  width: 1200px;
  margin-left: 20px;
}
.research-title-do {
  width: 906px;
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  line-height: 45px;
  margin: 30px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.activityCnSubTitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
}
.research-info {
  position: relative;
  width: 1170px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
  margin-bottom: 70px;
}
.activityTeach-info {
  position: relative;
  width: 1170px;
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
  margin-top: 40px;
}
.activityTeach-do {
  text-align: right;
  position: absolute;
  right: 0;
  top: -5px;
  width: 30%;
}
.activityTeach-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: right;
  font-weight: Regular;
}
.activityTeach-time {
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  text-align: right;
  font-weight: Regular;
}
.catholic-info {
  width: 100%;
  text-align: right;
}
.catholic-title {
  font-family: SourceHanSansCN-Heavy;
  font-size: 42px;
  color: #000000;
  letter-spacing: 0;
  text-align: right;
  font-weight: bold;
  margin-bottom: 12px;
}
.catholic-dec {
  font-family: SourceHanSansCN-Medium;
  font-size: 28px;
  color: #585c64;
  letter-spacing: 0;
  text-align: right;
  font-weight: 500;
  margin-bottom: 60px;
}
@media (max-width: 1440px) {
  .researchEducation {
    width: 98%;
    margin: 110px auto 30px;
  }
  .catholic-info {
    max-width: 92%;
    text-align: right;
  }
  .researchSlider-box {
    max-width: 92%;
    margin-left: 20px;
  }
  .activityTeach-info {
    position: relative;
    max-width: 100%;
  }
  .research-title-do {
    max-width: 100%;
  }
  .research-info {
    max-width: 100%;
  }
  .activityTeach-do {
    max-width: 60%;
    text-align: left;
    position: absolute;
    right: 0%;
    top: 45px;
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .researchEducation {
    width: 100%;
    margin: 110px auto 30px;
  }
  .researchSlider-box {
    max-width: 95%;
    margin-left: 20px;
  }
  .activityTeach-info {
    position: relative;
    max-width: 80%;
  }
  .research-title-do {
    max-width: 100%;
  }
  .research-info {
    max-width: 100%;
  }
  .activityTeach-do {
    display: none;
  }
}
@media (max-width: 960px) {
  .researchEducation {
    width: 92%;
    margin: 120px auto 30px;
  }
  .wap-act-tab {
    display: flex;
    margin: 0px auto;
    width: 100%;
    justify-content: center;
  }
  .wap-tab {
    margin: 0 10px 20px;
    border: 1px solid rgba(102, 102, 102, 1);
    border-radius: 4px;
    width: 80px;
    height: 30px;
    line-height: 28px;
    text-align: center;
    color: #000;
    font-size: 13px;
  }
  .actTap {
    background-color: #000;
    color: #fff;
  }
  .researchSlider-box {
    width: 100%;
    margin: 10px auto 0;
  }
  .research-title-do {
    width: 100%;
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    line-height: 28px;
    margin: 20px 0 10px;
  }
  
  .catholic-title{
    width: 100%;
    text-align: center;
  }
  .activityCnSubTitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
  }
  .research-info {
    position: relative;
    width: 100%;
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .researchSlider-wap {
    position: relative;
    width: 100%;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .res-wap {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin: 20px 0;
  }
  .reswap-title {
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .reswap-time {
    font-size: 12px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
  }
  .research-info-wap {
    position: relative;
    width: 98%;
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .activityTeach-info {
    position: relative;
    width: 100%;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    font-weight: 400;
    margin-top: 40px;
  }
  .activityTeach-do {
    text-align: left;
    position: relative;
    left: 0;
    top: 0px;
    width: 100%;
  }
  .activityTeach-title {
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
  .activityTeach-time {
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
  }
  .catholic-info {
    max-width: 100%;
    margin-top: 0px;
    text-align: center;
  }
  .catholic-title {
    font-family: SourceHanSansCN-Heavy;
    font-size: 23px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .catholic-dec {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #585c64;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    margin-bottom: 10px;
  }
}
@media (max-width: 768px) {
  .wap-tab {
    margin: 0 10px 20px;
    border: 1px solid rgba(102, 102, 102, 1);
    border-radius: 4px;
    width: 80px;
    height: 30px;
    line-height: 28px;
    text-align: center;
    color: #000;
    font-size: 13px;
  }
  .actTap {
    background-color: #000;
    color: #fff;
  }
}
@media (max-width: 428px) {
}
</style>